import React from "react";
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { BsPlusSquare } from "react-icons/bs";
import { TbBrandTelegram } from "react-icons/tb";
import { toast } from "react-hot-toast";
import { useState } from "react";
import {
  uploadUrlRealState,
  downloadUrlRealState,
  uploadUrl,
  downloadUrl,
} from "../../../confing/confing";
import axios from "axios";
import { useEffect } from "react";
import {
  getAllRealEstate,
  getEndRequest,
  sendForRealState,
} from "../../../services/kojaServices.js";
import Select from "react-select";
import { FaTrash } from "react-icons/fa";

const RealState = () => {
  const [loading, setLoading] = useState(false);
  const [realState, setRealEstates] = useState([]);
  const [requests, setRequests] = useState([]);
  const [imgArry, setImgArry] = useState([]);
  const [sheetId, setSheetId] = useState();
  const [RealStateList, setRealStateList] = useState([]);

  let selectfile = async (e, setFieldValue, values) => {
    try {
      setLoading(true);
      const imageFile = e.target.files[0];
      if (imageFile.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
        let size = (imageFile.size / 1024 / 1024).toFixed(2);
        if (size <= 3) {
          let datas = new FormData();
          datas.append("file", e.target.files[0]);
          const { data: imgname, status } = await axios.post(
            `${uploadUrlRealState}`,
            datas
          );
          let imgnamee = imgname.result.fileName;
          let arry = [...imgArry];
          arry.push(imgnamee);
          console.log(`${downloadUrlRealState}/${imgnamee}`);
          setImgArry(arry);
          setLoading(false);
        } else {
          toast.error("سایز عکس باید کمتر از 2 مگابایت باشد");
          setLoading(false);
        }
      } else {
        toast.error("فرمت عکس قابل قبول نیست");
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      toast.error("دوباره تلاش کنید");
      setLoading(false);
    }
  };

  const deleteImage = (i)=> {
    let copy = imgArry
     let newArry = copy.filter((name) => {return name !== i})
    setImgArry(newArry)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getAllRealEstate();
        let arry = [];
        data.result.map((i) => {
          let x = {
            value: i.id,
            label: i.agencyName,
            img: `${downloadUrl}${i.agencyLogo}`,
          };
          arry.push(x);
        });
        setRealEstates(arry);
        const { data: Request } = await getEndRequest();
        let arry2 = [];
        Request.result.map((i) => {
          let y = {
            value: i.expert[0].ExSheetId || 0,
            label: `${i.Ex_Category.name}-${i.address}`,
            token: i.requestToken,
          };
          arry2.push(y);
        });
        setRequests(arry2);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  const customStyles = {
    container: (provided, state) => ({
      ...provided,
      backgroundColor: "#d9d9d9",
      borderRadius: "90px",
      color: "#000",
      textAlign: "right",
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#d9d9d9",
      borderRadius: "90px",
      color: "#000",
      padding: "8px",
      height: "50px",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#fff",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: "#000",
    }),
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: "#d9d9d9",
      boxShadow: "0px 4px 4px #000000",
      borderRadius: "20px",
      color: "#000",
      padding: "8px",
    }),
  };

  const setSelectedRealState = (e) => {
    let aryy = [];
    e.map((i) => {
      aryy.push(i.value);
    });
    setRealStateList(aryy);
  };
  const submitForm = async () => {
    let sendSheet = document.getElementById("sendSheet").value;
    let description = document.getElementById("description").value;
    let sendData = {
      sendSheet: sendSheet,
      ExSheetId: sheetId,
      ExRealStateIds: RealStateList,
      OwnerComment: description,
      files: imgArry,
    };
    if (
      sheetId &&
      RealStateList.length > 0 &&
      description &&
      imgArry.length > 0
    ) {
      const { data } = await sendForRealState(sendData);
      toast.success("درخواست شما با موفقیت ارسال شد");
    } else {
      toast.error("لطفا تمامی فیلد هارو پر کنید");
    }
  };

  return (
    <div style={{ paddingTop: "10px", minHeight: "100vh" }}>
      <Header />
      <div
        className="d-flex request-box-content"
        style={{ margin: "20px 30px 0px 30px" }}
      >
        <Menu />
        <div className="w-100 text-center d-flex flex-column align-items-start justify-content-start">
          <div className="real-state-form-box">
            <Formik
              initialValues={{}}
              validationSchema={""}
              onSubmit={(values, { resetForm }) => {
                submitForm();
              }}
              enableReinitialize={true}
            >
              {({ isSubmitting, errors, setFieldValue, touched }) => (
                <Form>
                  <div className="row  align-items-center ">
                    <div>
                      <label htmlFor="upload_file" className=" upload-btn">
                        <p className="mb-2 mt-2">
                          <BsPlusSquare
                            style={{ width: "40px", height: "40px" }}
                          />
                        </p>
                        <p>آپلود فایل</p>
                      </label>
                      <input
                        type="file"
                        id="upload_file"
                        name="upload_file"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          selectfile(e, setFieldValue);
                        }}
                      ></input>
                    </div>
                    <div>
                      {loading && (
                        <div className="spinner-border mt-2" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                    </div>
                    <div className="row mt-2">
                      {imgArry.map((i, index) => (
                        <div key={index} className="col-lg-2 col-md-3 col-4">
                          <div className="realstete-imgs mb-4">
                            <img alt="s" src={`${downloadUrlRealState}/${i}`} />
                            <button
                              className="btn"
                              style={{
                                marginTop: "-30%",
                                backgroundColor: "#c9c9c9",
                              }}
                              onClick={()=> {deleteImage(i)}}
                              type="button"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="mt-3 col-12 ">
                      <Select
                        placeholder="صورت کارشناسی"
                        styles={customStyles}
                        options={requests}
                        onChange={(e) => {
                          setSheetId(e.value);
                        }}
                        components={{
                          Option: ({ innerProps, label, data }) => (
                            <div {...innerProps} className="mb-2">
                              <p>{label}</p>
                              <p>صورت کارشناسی : {data.token}</p>
                              <hr />
                            </div>
                          ),
                        }}
                      />
                    </div>
                    <div className="mt-3 col-12 ">
                      <Select
                        placeholder="مشاوره املاک"
                        closeMenuOnSelect={false}
                        isMulti
                        styles={customStyles}
                        options={realState}
                        onChange={(e) => {
                          setSelectedRealState(e);
                        }}
                        components={{
                          Option: ({ innerProps, label, data }) => (
                            <div {...innerProps} className="mb-2">
                              <img
                                className="ms-3"
                                src={data.img}
                                alt={label}
                                width="40"
                                height="40"
                                style={{
                                  marginRight: "5px",
                                  borderRadius: "20px",
                                }}
                              />
                              {label}
                            </div>
                          ),
                        }}
                      />
                    </div>
                    <div className="mt-3 col-12 ">
                      <input
                        id="description"
                        name="description"
                        type="text"
                        className="w-100 form-control real-state-form-input"
                        placeholder="توضیحات:"
                        style={{ height: "80px" }}
                      />
                    </div>
                    <div className="mt-3 text-end me-2">
                      <label>
                        <Field
                          id="sendSheet"
                          className="ms-1"
                          type="checkbox"
                          name="toggle"
                        />
                        آپلود صورت کارشناسی
                      </label>
                    </div>
                    <div
                      className="mt-3 m-auto request-next-btn-box"
                      style={{ width: "250px", height: "80px" }}
                    >
                      <button
                        type="submit"
                        className="btn request-next-btn"
                        style={{ width: "220px", height: "60px" }}
                      >
                        ارسال برای املاک <TbBrandTelegram />
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealState;
